'use strict';

const urlJoin = require('url-join');
const config = require('../config');
const { default: stipulate, buildOptions } = require('stipulate');
const { baseOptions } = require('./configuration');

const getProductBoardToken = () => {
  const { baseUrl } = config.get();

  const url = urlJoin(baseUrl, '/pb/users/me/generate-product-board-sso-token/');
  const requestOptions = buildOptions(baseOptions, {
    method: 'POST',
  });

  return stipulate(url, requestOptions);
};

module.exports = getProductBoardToken;
